import React from 'react'
import UserHeaderComponent from "../General/UserHeaderComponent"
import TopAddComponent from "../General/TopAddComponent"
import LeftAddComponent from "../General/LeftAddComponent"
import RightAddComponent from "./RightAddComponent"
import LatestArticleComponent from "../General/LatestArticleComponent"
import FooterComponent from "../General/FooterComponent"
const UserWrapperComponent = (HocComponent) => {
    const UserWrapper = (props) => {
        return (
            <>
                <UserHeaderComponent
                    {...props}
                />
                <TopAddComponent />
                <section className="Main_body">
                    <div className="row">
                        <div className="col-md-12 col-lg-2 left_1">
                            <LeftAddComponent />
                            <LatestArticleComponent />

                        </div>
                        <div className="col-md-12 col-lg-8 center_2">
                            <HocComponent {...props} />
                        </div>
                        <div className="col-md-12 col-lg-2 Right_3">
                            <RightAddComponent />
                        </div>
                    </div>
                </section>
                <FooterComponent />
            </>);
    };
    return UserWrapper;
};
export default UserWrapperComponent;